import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../constants";
import { Loading } from "../components/Loading";
import { NoMatch } from "../components/NoMatch";
import { useBranding } from "./Branding";
import './StaticPage.css';

interface PageItem {
  title: string;
  content: string;
  titleColor?: string | null;
}

export const StaticPage = () => {
  const params = useParams<{ language: string; page: string }>();
  const { setBranding } = useBranding();

  const [loading, setLoading] = useState(true);
  const [pageItem, setPageItem] = useState<PageItem>({
    title: '',
    content: ''
  })

  useEffect(() => {
    const page = params.page ?? "";
    if (page) {
      setLoading(true);
      const language = params.language ?? 'en';
      fetch(`${API_URL}/admin/agreement/public/${page}/${language}`,).then(async response => {
        const result = await response.json();
        const content = result?.content;
        setPageItem({
          title: content?.title,
          content: content?.content,
          titleColor: content?.titleColor,
        })
        // The header logo lives in the layout, so hand the page's branding up to it.
        setBranding({ logoUrl: content?.logoUrl, titleColor: content?.titleColor });
      }).finally(() => {
        setLoading(false);
      })
    }
    // Back to the default branding when leaving the page.
    return () => setBranding({});
  }, [params.page, params.language, setBranding]);

  if (loading) {
    return <Loading/>;
  }

  const titleStyle = pageItem.titleColor ? { color: pageItem.titleColor } : undefined;

  return (
    <section className="static-page">
      {pageItem?.title && <h1 style={titleStyle}>{pageItem.title}</h1>}
      {pageItem?.content && <article dangerouslySetInnerHTML={{ __html: pageItem.content }}/>}

      {!pageItem?.title && !pageItem?.content && (
        <NoMatch/>
      )}
    </section>
  )
};
